import { CimStreamRequestData } from '../data/cim-stream';
import { PerformanceProfileDataType } from './performance-profile-data-type';

/**
 * Powershell information.
 */
export interface PerformanceProfileDataPowerShell {
    command?: string;
    sessionId?: string;
    completed?: string;
}

/**
 * CIM information.
 */
export interface PerformanceProfileDataCim {
    namespace: string;
    className?: string;
    query?: string;
}

/**
 * Xhr or fetch information.
 */
export interface PerformanceProfileXhrFetch {
    url: string;
    method: string;
    status: number;
    powershell?: PerformanceProfileDataPowerShell;
    cim?: PerformanceProfileDataCim;
    batch?: PerformanceProfileXhrFetch[];
}

/**
 * WebSocket information.
 */
export interface PerformanceProfileWebsocket {
    nodeName: string;
    id: number;
    count: number;
    itemCount: number;
    powershell?: PerformanceProfileDataPowerShell;
    cim?: CimStreamRequestData;
}

/**
 * Performance profile data.
 */
export interface PerformanceProfileData {
    source: string;
    start: number;
    end: number;
    errorMessage?: string;
    type: PerformanceProfileDataType;
    xhrFetch?: PerformanceProfileXhrFetch;
    webSocket?: PerformanceProfileWebsocket;
    routeNavigation?: {
        url: string;
        target?: string;
    };
}
